import { render, staticRenderFns } from "./Handbook.vue?vue&type=template&id=cced120a&"
import script from "./Handbook.vue?vue&type=script&lang=js&"
export * from "./Handbook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports